import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Popover,
    Radio,
    RadioGroup,
} from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { updateCalendarEventOutcome } from '../../../asyncHelpers/calendarEventsService';
import { CalendarEvent } from '../../../sic-lib/types/CalendarEvent';
import { useAppDispatch } from '../../../store/hooks';

const useStyles = makeStyles()(theme => ({
    root: {
        height: '100%',
        padding: theme.spacing(2),
    },
    actionWrapper: {
        flexBasis: '48px',
    },
    scrollWrapper: {
        height: 'calc(100% - 48px)',
        overflow: 'hidden',
    },
    button: {
        padding: '10px',
    },
}));

interface Props {
    parentEl: HTMLButtonElement | null;
    calendarEvent: CalendarEvent;
    setParentEl: (value: React.SetStateAction<HTMLButtonElement | null>) => void;
}

export default function CalendarEventOutcomePopover({
    calendarEvent,
    parentEl,
    setParentEl,
}: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const handleClose = () => {
        setParentEl(null);
    };

    const [outcome, setOutcome] = React.useState(calendarEvent.outcome || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOutcome(event.target.value);
    };

    const handleSave = async () => {
        await updateCalendarEventOutcome(calendarEvent.eventId, outcome);
        setParentEl(null);
    };

    const open = Boolean(parentEl);
    const id = open ? `calendar-event-outcome-popover-${calendarEvent.eventId}` : undefined;

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={parentEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <Grid container direction="column" wrap="nowrap" className={classes.root}>
                <Grid item>
                    <Grid container direction="row" wrap="nowrap" alignItems="center">
                        <Grid item xs={true}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Event Outcome</FormLabel>
                                <RadioGroup name="outcome" value={outcome} onChange={handleChange}>
                                    <FormControlLabel value="" control={<Radio />} label="None" />
                                    <FormControlLabel
                                        value="Signed"
                                        control={<Radio />}
                                        label="Signed (Met and signed contract)"
                                    />
                                    <FormControlLabel
                                        value="Not Signed"
                                        control={<Radio />}
                                        label="Not Signed (Met but have not signed contract)"
                                    />
                                    <FormControlLabel
                                        value="No Show"
                                        control={<Radio />}
                                        label="No Show (Contact did not show)"
                                    />
                                    <FormControlLabel
                                        value="Rescheduled"
                                        control={<Radio />}
                                        label="Rescheduled (Rescheduled)"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
                        <Grid item xs={true}></Grid>
                        <Grid item xs="auto">
                            <Button onClick={handleClose}>Cancel</Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Button variant="outlined" color="secondary" onClick={handleSave}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Popover>
    );
}

//<Tooltip title='Create Calendar Event'>
//    <IconButton onClick={handleHideOpenNewCalendarDrawer} className={classes.button}>
//        <InsertInvitationIcon />
//    </IconButton>
//</Tooltip>
